import React from 'react';

import { VisuallyHidden } from '@rbilabs/components-library';
import { useIntl } from 'react-intl';

import { ICartEntry } from '@rbi-ctg/menu';
import useAddToCartRecentItem from 'hooks/use-add-to-cart-recent-item';

import AddIcon from '../icons/add-icon';

import { IconButton, fill } from './styled';

interface AddToCartProps {
  disabled: boolean;
  cartEntry: ICartEntry;
}

const AddToCart: React.FC<AddToCartProps> = ({ disabled, cartEntry }) => {
  const { formatMessage } = useIntl();
  const { addToCart } = useAddToCartRecentItem({
    cartEntry,
  });

  return (
    <IconButton disabled={disabled} data-testid="add-to-cart" onClick={addToCart}>
      <VisuallyHidden>{formatMessage({ id: 'addToCart' })}</VisuallyHidden>
      <AddIcon fill={fill} />
    </IconButton>
  );
};

export default AddToCart;
